export default {
  set_row (context, parameter) {
    context.commit('SET_ROW', parameter)
  },
  set_bank (context, parameter) {
    context.commit('SET_BANK', parameter)
  },
  set_active (context, parameter) {
    context.commit('SET_ACTIVE', parameter)
  },
  set_shopRow (context, parameter) {
    context.commit('SET_SHOPROW', parameter)
  },
  set_userInfo (context, parameter) {
    context.commit('SET_USERINFO', parameter)
  },
  set_systemInfo (context, parameter) {
    context.commit('SET_SYSTEMINFO', parameter)
  },
  set_keepAliveList (context, parameter) {
    context.commit('SET_KEEPALIVELIST', parameter)
  },
  set_problemInfo (context, parameter) {
    context.commit('SET_PROBLEMINFO', parameter)
  },
  set_noticeInfo (context, parameter) {
    context.commit('SET_NOTICEINFO', parameter)
  },
  set_payInfo (context, parameter) {
    context.commit('SET_PAYINFO', parameter)
  },
  set_selectFreightModels (context, parameter) {
    context.commit('SET_SELECTFREIGHTMODELS', parameter)
  }
}
